"use strict";

import $ from "core-js/internals/export";
$({
  target: "Promise",
  stat: true
}, {
  allSettled: promises => {
    const wrappedPromises = promises.map(p => Promise.resolve(p).then(val => ({
      status: "fulfilled",
      value: val
    }), err => ({
      status: "rejected",
      reason: err
    })));
    return Promise.all(wrappedPromises);
  }
});